<template>
    <rkm-form
        ref="Form"
        show-legend
    >
        <rkm-row>
            <rkm-col cols="6">
                <rkm-form-select
                    :options="data.form.unidades"
                    :validations="validations.unidade"
                    @change="handleUnidadeChange"
                    label="Unidade"
                    show-default-option
                    text-field="nomeFantasia"
                    v-model="model.unidadeId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-select
                    :options="data.form.infraestruturas"
                    :validations="validations.infraestrutura"
                    label="Local de atendimento"
                    show-default-option
                    text-field="nome"
                    v-model="model.infraestruturaId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import { repository, error, object } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    computed: {
        validations() {

            return {
                unidade: { required: true },
                infraestrutura: { required: true },
            }
        },
    },
    created() {

        this.repositories = {
            parametrizacao: this.getConectaSusRepository('regulacao.parametrizacao')
        }
    },
    data: () => ({
        model: {
            unidadeId: null,
            infraestruturaId: null,
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        handleUnidadeChange() {

            this.data.form.infraestruturas = []
            this.model.infraestruturaId = null

            if (this.model.unidadeId) {

                this.loadInfraestruturas()
            }
        },
        loadInfraestruturas() {

            this.setLoading()

            this.repositories.parametrizacao.list({
                listar: 'infraestruturas',
                unidade_id: this.model.unidadeId
            })
                .then(({ data }) => {

                    this.data.form.infraestruturas = data

                    if (this.data.form.infraestruturas.length === 1) {

                        this.model.infraestruturaId = this.data.form.infraestruturas[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    if (this.data.model.dataDesejadaInfraestruturas.some(i => i.id === this.model.infraestruturaId)) {

                        this.showAlert('Local de atendimento já existente.', 'Atenção')

                        return;
                    }

                    this.data.model.dataDesejadaInfraestruturas.push(this.prepareData())

                    this.$emit('save')
                })
        },
        prepareData() {

            return {
                id: this.model.infraestruturaId,
                nome: this.data.form.infraestruturas.find(i => i.id === this.model.infraestruturaId).nome,
                unidadeNomeFantasia: this.data.form.unidades.find(u => u.id === this.model.unidadeId).nomeFantasia,
            }
        }
    },
    mixins: [repository, error, object],
    props: {
        data: { type: Object, required: true },
    },
}
</script>